export const shortenDescription = (value, maxLength) => {
  const text = String(value || '').trim();
  const characters = Array.from(text);

  if (characters.length <= maxLength) {
    return text;
  }

  return `${characters.slice(0, maxLength).join('')}...`;
};
